import ReviewsSlider from "../../../components/reviews-slider";
import CompaniesSlider from "../../../components/companies-slider";
import VideoModal from "../../../components/base/video-modal";
export default class PageModule {
	constructor() {
		this.initAboutSchoolVideo();
		this.initCompaniesSlider();
		this.initReviewsSlider();
	}

	initAboutSchoolVideo() {
		const videoModal = new VideoModal({
			id: 'about-school'
		});
	}

	initCompaniesSlider() {
		const companiesSlider = new CompaniesSlider();
	}

	initReviewsSlider() {
		const reviewsSlider = new ReviewsSlider();
	}
}